<template>
  <div class="container">
    <div class="message">
      <p class="dutch">Laden…</p>
      <p class="english">Loading…</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'loading'
}
</script>

<style scoped>
.container, .message {
  width: 100%;
  height: 100%;
}
</style>
